import type { LocationKey, LocationModel } from '../types';

export function convertToLocationKey(location: LocationModel | null | undefined): LocationKey | null {
    const text = getLocationName(location);

    return text ? {
        text,
        placeId: location?.normalized?.placeId
    } : null;
}

export function getLocationName(location: LocationModel | null | undefined): string | null {
    if (location === null || location === undefined) {
        return null;
    }

    return location.normalized?.formattedAddressLocalLang || location.normalized?.formattedAddressLocalLang || location.originalText || '';
}
